import { render, staticRenderFns } from "./RedPackageGame.vue?vue&type=template&id=ed6ce238&scoped=true&"
import script from "./RedPackageGame.vue?vue&type=script&lang=js&"
export * from "./RedPackageGame.vue?vue&type=script&lang=js&"
import style0 from "./RedPackageGame.vue?vue&type=style&index=0&id=ed6ce238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6ce238",
  null
  
)

export default component.exports